import { useMemo } from "react";
import {
  canEdit,
  getUserRole,
  isManager,
  isReadOnly,
} from "../../helpers/rbac_helper";

/**
 * Hook for role-based UI permissions.
 * Mirrors localStorage role used by rbac_helper (same source as login).
 */
export const usePermissions = () => {
  const role = getUserRole();
  const readOnly = isReadOnly();
  const manager = isManager();
  const editable = canEdit();

  return useMemo(
    () => ({
      role,
      isReadOnly: readOnly,
      isManager: manager,
      canEdit: editable,
    }),
    [role, readOnly, manager, editable]
  );
};

export default usePermissions;
